import React, { useEffect, useState } from "react";
import { Image, StyleSheet, Text, View } from "react-native";
import { connect } from "react-redux";
import {
  removeCartItem,
  setCartItems,
  updateCartItem,
} from "../../actions/cart";
import { addFavItem } from "../../actions/fav";
import { setCheckoutOrderInfo } from "../../actions/order";
import { fetchApi } from "../../api";
import { STYLES } from "../../assets/styles";
import AccountVerification from "../../components/AccountVerification";
import Container from "../../components/Container";
import Content from "../../components/Content";
import CustomButton from "../../components/CustomButton";
import CustomIcon from "../../components/CustomIcon";
import Header from "../../components/Header";
import Loading from "../../components/Loading";
import Price from "../../components/Price";

function Cart({
  navigation,
  updateCartItem,
  cartItems = [],
  addFavItem,
  removeCartItem,
  setCartItems,
  setCheckoutOrderInfo,
  userData = {},
}) {
  const [isReady, setIsReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [verifyUser, setVerifyUser] = useState(null);
  const [amountInfo, setAmountInfo] = useState({
    total: 0,
    discount: 0,
    amount: 0,
  });

  const updateAmountInfo = (cartItems) => {
    let amountInfo = cartItems.reduce(
      (acc, { price, mrp, count }) => {
        let t = count * mrp;
        let a = count * price;
        acc.total += t;
        acc.amount += a;
        acc.discount += t - a;
        return acc;
      },
      { total: 0, discount: 0, amount: 0 }
    );
    setAmountInfo(amountInfo);
  };

  useEffect(() => {
    updateAmountInfo(cartItems);
    setIsReady(true);
  }, [cartItems]);

  const handleItemCountUpdate = (index, price, mrp, inc) => {
    let itemCount = cartItems[index].count;
    if (itemCount > 0 || inc > 0) {
      let t = inc * mrp;
      let a = inc * price;
      setAmountInfo({
        total: amountInfo.total + t,
        amount: amountInfo.amount + a,
        discount: amountInfo.discount + (t - a),
      });
      updateCartItem({ index: index, data: { count: itemCount + inc } });
    }
  };

  const handleMoveToFav = ({ _id, item_id, title, image_url }) => {
    setLoading(true);
    fetchApi({
      path: "/favitems",
      method: "POST",
      body: {
        item_id,
        title,
        image_url,
      },
    }).then((res) => {
      if (!res.error) {
        addFavItem(res);
        fetchApi({
          path: `/cart/${_id}`,
          method: "DELETE",
        }).then((res) => {
          if (!res.error) {
            removeCartItem({ item_id, _id });
          }
        });
      }
      setLoading(false);
    });
  };

  const navigateToOrderScreen = () => {
    let orderInfo = {};
    orderInfo["items"] = cartItems.filter(({ count }) => count > 0);
    orderInfo["amount"] = amountInfo.amount;
    setCheckoutOrderInfo(orderInfo);
    navigation.navigate("tabs", {
      screen: "cart",
      params: { screen: "placeorder" },
    });
  };

  const handleCheckoutOrder = () => {
    if (userData.is_verified) {
      navigateToOrderScreen();
    } else {
      setVerifyUser(userData._id);
    }
  };

  const Item = ({
    image_url,
    title,
    size,
    item_id,
    discount,
    price,
    mrp,
    count,
    index,
    _id,
  }) => (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        ...STYLES.shadow,
        margin: 5,
      }}
    >
      <Image
        source={{ uri: image_url }}
        resizeMode="contain"
        style={{ width: 70, height: 70, margin: 10 }}
      />
      <View style={{ flex: 1, marginVertical: 5 }}>
        <Text style={{ fontSize: STYLES.fontSizes.mini }}>{title}</Text>
        <Text style={styles.smallFont}>Size : {size}</Text>
        <Price
          price={price}
          discount={discount}
          mrp={mrp}
          style={{ flexDirection: "row" }}
          size={STYLES.fontSizes.small}
        />
      </View>
      <View>
        <View
          style={{
            flexDirection: "row",
            margin: 5,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CustomIcon
            type="AntDesign"
            name="minus"
            style={styles.btn}
            onPress={() => handleItemCountUpdate(index, price, mrp, -1)}
          />
          <Text style={{ fontSize: 20 }}>{count}</Text>
          <CustomIcon
            type="AntDesign"
            name="plus"
            style={styles.btn}
            onPress={() => handleItemCountUpdate(index, price, mrp, 1)}
          />
        </View>
        {!count ? (
          <CustomButton
            text="Move it to Favourate"
            btnStyle={{
              width: 60,
              padding: 0,
            }}
            onPress={() =>
              handleMoveToFav({
                _id,
                title,
                image_url,
                item_id,
                index,
              })
            }
            textStyle={{
              fontSize: STYLES.fontSizes.mini * 0.8,
              color: STYLES.colors.tomato,
            }}
          />
        ) : null}
      </View>
    </View>
  );

  const onRefresh = () => {
    setRefreshing(true);
    fetchApi({
      path: "/cart",
    }).then((res) => {
      if (res.results) {
        setCartItems(res.results);
        updateAmountInfo(res.results);
      }
      setRefreshing(false);
    });
  };

  return (
    <Container secure>
      {verifyUser ? (
        <AccountVerification
          userId={verifyUser}
          onClose={() => {
            setVerifyUser(null);
          }}
          onSuccess={navigateToOrderScreen}
        />
      ) : (
        <>
          <Header backButton title="Cart" navigation={navigation} />
          <Content
            scrollEnabled
            refreshable
            refreshing={refreshing}
            onRefresh={onRefresh}
            loading={!isReady}
            empty={
              cartItems.length > 0
                ? null
                : {
                    iconType: "Fontisto",
                    iconName: "shopping-bag-1",
                    text: "No Items added to the cart",
                  }
            }
            style={{ flex: 1 }}
          >
            {cartItems.map((data, index) => (
              <Item key={index} {...data} index={index} />
            ))}
            <View style={{ marginVertical: 35 }}>
              <View style={styles.txtContainer}>
                <Text>Total Amount</Text>
                <Text>{amountInfo.total}</Text>
              </View>
              <View style={styles.txtContainer}>
                <Text>Discount</Text>
                <View style={{ flexDirection: "row", alignItems: "baseline" }}>
                  <Text
                    style={{
                      fontSize: STYLES.fontSizes.mini,
                      fontWeight: "bold",
                      color: STYLES.colors.carribeanGreen,
                    }}
                  >
                    saved
                  </Text>
                  <Text
                    style={{
                      fontSize: STYLES.fontSizes.mini,
                      fontWeight: "bold",
                      marginHorizontal: 5,
                      color: STYLES.colors.purpel,
                    }}
                  >
                    {parseInt((amountInfo.discount / amountInfo.total) * 100) ||
                      0}{" "}
                    %
                  </Text>
                  <Text>- {amountInfo.discount}</Text>
                </View>
              </View>
              <View
                style={[
                  styles.txtContainer,
                  {
                    ...STYLES.shadow,
                    padding: 10,
                  },
                ]}
              >
                <Text style={{ fontWeight: "bold" }}>Amount payable</Text>
                <Text style={{ fontWeight: "bold" }}>{amountInfo.amount}</Text>
              </View>
            </View>
            <CustomButton
              text={
                userData.is_verified ? "Checkout Order" : "Verify Your Account"
              }
              leftIcon={{ type: "SimpleLineIcons", name: "basket-loaded" }}
              iconStyle={{ color: "#ffffff" }}
              btnStyle={{
                backgroundColor: "#000000",
                width: "80%",
                alignSelf: "center",
              }}
              onPress={handleCheckoutOrder}
              textStyle={{ color: "#ffffff" }}
            />
          </Content>
          {loading ? <Loading spinner /> : null}
        </>
      )}
    </Container>
  );
}

const styles = StyleSheet.create({
  btn: {
    fontSize: 10,
    marginHorizontal: 3,
    borderWidth: 1,
    borderRadius: 20,
  },
  txtContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    margin: 5,
    paddingHorizontal: 5,
  },
  value: {
    fontWeight: "bold",
  },
  smallFont: { fontSize: STYLES.fontSizes.small, fontWeight: "bold" },
});

const mapStateToProps = (state) => ({
  cartItems: state.cart.items,
  userData: state.user.userData,
});

const mapDispatchToProps = (dispatch) => ({
  updateCartItem: (data) => dispatch(updateCartItem(data)),
  addFavItem: (data) => dispatch(addFavItem(data)),
  removeCartItem: (data) => dispatch(removeCartItem(data)),
  setCheckoutOrderInfo: (data) => dispatch(setCheckoutOrderInfo(data)),
  setCartItems: (data) => dispatch(setCartItems(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
